import { render } from "./GridStudii.vue?vue&type=template&id=647e9220&ts=true"
import script from "./GridStudii.vue?vue&type=script&lang=ts"
export * from "./GridStudii.vue?vue&type=script&lang=ts"

import "./GridStudii.vue?vue&type=style&index=0&id=647e9220&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__